import { PageHeader, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import {
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  EditableTableDatePickerItem,
  SegmentedItem
} from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { DollarOutlined, EyeOutlined, ScheduleOutlined } from "@ant-design/icons";
import ModalEditarFechas from "../../../Components/ModalEditarFechas";

moment.locale("es");

const {
  EditableRow,
  EditableCell
} = EditableTableDatePickerItem

class CuentasPorPagar extends Component {
  state = {
    todasCuentasPorPagar: [],
    todasCuentasPorPagarProveedor: [],
    agruparPorProveedor: false,
    total: 0,
    loading: false,
    valor: 3,
    facturaSeleccionada: null,
    modalEditarFechas : false,
    rangosLeyenda: [],
    usarColores: false,
  };
  componentDidMount() {
    this.consultarCuentasPorPagar(this.state.valor);
    this.consultarConfiguracionVencimiento();
  }

  async consultarConfiguracionVencimiento() {
    axios
      .post(
          "empresas/selectConfiguracionVencimiento",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
      )
      .then((res) => {
          if (res.data.success === 2) {
              this.setState({
                  usarColores: res.data.configuracion.usarColoresVencimiento,
                  rangosLeyenda: res.data.configuracion.rangosDiasVencimiento || []
              });
          }
      });
  }

  async consultarCuentasPorPagar(valor) {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentasporpagar/selectFacturas",
        { empresaId: this.props.empresaId, valor: valor },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          this.setState({ todasCuentasPorPagar: [] });
        } else {
          this.setState({
            todasCuentasPorPagar: res.data.facturas,
            total: dineroDisabledMask(res.data.saldoTotalPendienteMXN)
          });
        }
      });
  }
  async consultarCuentasPorPagarProveedor() {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentasporpagar/selectCuentasPProveedor",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          this.setState({ todasCuentasPorPagarProveedor: [] });
        } else {
          this.setState({
            todasCuentasPorPagarProveedor: res.data.cuentas,
            total: dineroDisabledMask(res.data.saldoTotalPendienteMXN)
          });
        }
      });
  }
  pagarFactura(id, cheque) {
    this.props.history.push("/panel/pagarFactura", { id, cheque });
  }
  verProveedor(id, nombre, cheque, rfc) {
    this.props.history.push("/panel/verFacturasProveedor", {
      id,
      nombre,
      cheque,
      rfc,
    });
  }
  async agrupar() {
    const agrupar = !this.state.agruparPorProveedor;
    if (agrupar) {
      await this.consultarCuentasPorPagarProveedor();
    } else {
      await this.consultarCuentasPorPagar(this.state.valor);
    }
    this.setState({ agruparPorProveedor: agrupar });
  }

  
  abrirModalEditarFechas(venta) {
    this.setState({
      modalEditarFechas: true,
      facturaSeleccionada: venta,
    });
  }

  cerrarModalEditarFechas(recargar = false) {
    this.setState({
      modalEditarFechas: false,
      facturaSeleccionada: null,
    });

    if (recargar) {
      this.consultarCuentasPorPagar(this.state.valor); 
    }
  }
  render() {
    //Colores fijos para los iconos de las columnas 
    const coloresFijos = [
        'rgba(236, 251, 241, 1)', // Verde claro
        'rgba(223, 247, 230, 1)', // Verde
        'rgba(255, 244, 204, 1)', // Amarillo
        'rgba(255, 226, 204, 1)', // Naranja
        'rgba(255, 214, 214, 1)', // Rojo
    ];
    const estadosLeyendaDinamicos = this.state.usarColores 
    ? this.state.rangosLeyenda.map((rango, index) => ({
        color: coloresFijos[index] || 'rgba(200, 200, 200, 1)', // Color por defecto si hay más de 5
        label: rango.nombre,
        key: `rango-${index}`,
        tope: rango.tope
    }))
    : [];
    
    const isMobile = window.innerWidth <= 1000;
    const fechaVen = 
      {
        title: "Vencimiento",
        dataIndex: "fechaVencimiento",
        key: "fechaVencimiento",
        sorter: (a, b) => {
          if (moment(a.fechaVencimiento) < moment(b.fechaVencimiento)) {
            return -1;
          }
          if (moment(a.fechaVencimiento) > moment(b.fechaVencimiento)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale("es").format("L"),
        width: isMobile ? "5%" : "20%",
      }
    const fechaPago = 
      {
        title: "Prob. Pago",
        dataIndex: "fechaPago",
        key: "fechaPago",
        sorter: (a, b) => {
          if (moment(a.fechaPago) < moment(b.fechaPago)) {
            return -1;
          }
          if (moment(a.fechaPago) > moment(b.fechaPago)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale("es").format("L"),
        width: isMobile ? "5%" : "20%",
      }

    const columns = this.state.agruparPorProveedor
      ? [
          {
            title: "Proveedor",
            dataIndex: "proveedorNombre",
            key: "proveedorNombre",
            responsive: ["md"],
            sorter: (a, b) => {
              if (a.proveedorNombre < b.proveedorNombre) {
                return -1;
              }
              if (a.proveedorNombre > b.proveedorNombre) {
                return 1;
              }
              return 0;
            },
            buscar: "proveedorNombre",
            width: "32%",
          },
          {
            title: "Fecha de Vencimiento",
            dataIndex: "fechaPago",
            key: "fechaPago",
            sorter: (a, b) => {
              if (moment(a.fechaPago) < moment(b.fechaPago)) {
                return -1;
              }
              if (moment(a.fechaPago) > moment(b.fechaPago)) {
                return 1;
              }
              return 0;
            },
            render: (value) => moment(value).locale("es").format("LL"),
            width: "15%",
            align: "center",
          },
          {
            title: "Total a Pagar / Pagado",
            dataIndex: "totalPagar",
            key: "totalPagar",
            responsive: ["md"],
            sorter: (a, b) => {
              if (a.totalPagar < b.totalPagar) {
                return -1;
              }
              if (a.totalPagar > b.totalPagar) {
                return 1;
              }
              return 0;
            },
            render: (_, record) => (
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                  <span>{dineroDisabledMask(record.totalPagar)}</span>
                  {record.abreviacionMoneda && <span style={{ fontSize: "12px", color: "#999" }}>{record.abreviacionMoneda}</span>}

                </div>
                <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                  <span>{dineroDisabledMask(record.totalPagado)}</span>
                  {record.abreviacionMoneda && <span style={{ fontSize: "12px", color: "#999" }}>{record.abreviacionMoneda}</span>}

                </div>
              </div>
            ),
            width: "13%",
            align: "right",
          },
          {
            title: "Total Pagado",
            dataIndex: "totalPagado",
            key: "totalPagado",
            sorter: (a, b) => {
              if (a.totalPagado < b.totalPagado) {
                return -1;
              }
              if (a.totalPagado > b.totalPagado) {
                return 1;
              }
              return 0;
            },
            responsive: [],
            width: 0,
          },
          {
            title: "Saldo Pendiente",
            dataIndex: "saldoPendiente",
            key: "saldoPendiente",
            sorter: (a, b) => {
              if (a.saldoPendiente < b.saldoPendiente) {
                return -1;
              }
              if (a.saldoPendiente > b.saldoPendiente) {
                return 1;
              }
              return 0;
            },
            render: (_, record) => (
              <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                <span>{dineroDisabledMask(record.saldoPendiente)}</span>
                {record.abreviacionMoneda && <span style={{ fontSize: "12px" }}>{record.abreviacionMoneda}</span>}
              </div>
            ),
            width: "13%",
            align: "right",
          },
          {
            title: "Vencimiento",
            dataIndex: "accion",
            responsive: ["md"],
            key: "vencimiento",
            render: (value, record, index) => {
              if (moment() > moment(value.fechaVencimiento)) {
                return (
                  <Tag key={`vencido-${index}`} color="red" className="square-tag3">
                  {moment().diff(moment(value.fechaVencimiento), 'days')} días
                  </Tag>
                );
              }
              return null;
            },
            width: "10%",
          },
          {
            title: "Acción",
            dataIndex: "accion",
            key: "accion",
            align: "center",
            width: "10%",
            onHeaderCell: () => ({
              style: { textAlign: 'center', padding: '4px' }
            }),
            onCell: () => ({
              className: "acciones-sin-hover",
              style: { textAlign: 'center', padding: '4px' }
            }),
            render: (value, record, index) => {
              if(!value.poderPagar) return null;

              let buttons = [];

              const puedePagar = this.props.permisoPagar;
              if (puedePagar) {
                buttons.push(
                  <Tooltip key={`pagar-${index}`} title="Pagar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      amarillo
                      icon={<DollarOutlined />}
                      onClick={() => this.verProveedor(value._id, value.nombre, value.cheque, value.rfc)}
                    >
                    </ButtonItem>
                  </Tooltip>
                );
              }

              return <div className="acciones-container">{buttons}</div>;
            },
          },
        ]
      : [
          {
            title: "Codigo",
            dataIndex: "codigoFactura",
            key: "codigoFactura",
            responsive: ["md"],
            sorter: (a, b) => {
              if (a.codigoFactura < b.codigoFactura) {
                return -1;
              }
              if (a.codigoFactura > b.codigoFactura) {
                return 1;
              }
              return 0;
            },
            buscar: "codigoFactura",
            width: "36%",
          },
          {
            title: "Proyecto",
            dataIndex: "proyectoNombre",
            key: "proyectoNombre",
            responsive: ["md"],
            sorter: (a, b) => {
              if (a.proyectoNombre < b.proyectoNombre) {
                return -1;
              }
              if (a.proyectoNombre > b.proyectoNombre) {
                return 1;
              }
              return 0;
            },
            buscar: "proyectoNombre",
            width: "20%",
          },
          {
            title: "Proveedor",
            dataIndex: "proveedorNombre",
            key: "proveedorNombre",
            responsive: ["md"],
            sorter: (a, b) => {
              if (a.proveedorNombre < b.proveedorNombre) {
                return -1;
              }
              if (a.proveedorNombre > b.proveedorNombre) {
                return 1;
              }
              return 0;
            },
            buscar: "proveedorNombre",
            width: "32%",
          },
          fechaVen,
          fechaPago,
          {
            title: "Fecha Fac.",
            dataIndex: "fechaFactura",
            key: "fechaFactura",
            responsive: ["md"],
            sorter: (a, b) => {
              if (moment(a.fechaFactura) < moment(b.fechaFactura)) {
                return -1;
              }
              if (moment(a.fechaFactura) > moment(b.fechaFactura)) {
                return 1;
              }
              return 0;
            },
            render: (value) => moment(value).locale("es").format("DD/MM/YYYY"),
            width: "20%",
            align: "center",
          },
          {
            title: "T.C.",
            dataIndex: "tipoDeCambio",
            key: "tipoDeCambio",
            responsive: ["md"],
            width: "12%",
          },
          {
            title: "Total a Pagar / Pagado",
            dataIndex: "totalPagar",
            key: "totalPagar",
            responsive: ["md"],
            sorter: (a, b) => {
              if (a.totalPagar < b.totalPagar) {
                return -1;
              }
              if (a.totalPagar > b.totalPagar) {
                return 1;
              }
              return 0;
            },
            render: (_, record) => (
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                  <span>{dineroDisabledMask(record.totalPagar)}</span>
                  {record.moneda && <span style={{ fontSize: "12px", color: "#999" }}>{record.moneda}</span>}
                </div>
                <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                  <span>{dineroDisabledMask(record.totalPagado)}</span>
                  {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                </div>
              </div>
            ),
            width: "35%",
            align: "right",
          },
          {
            title: "Total Pagado",
            dataIndex: "totalPagado",
            key: "totalPagado",
            sorter: (a, b) => {
              if (a.totalPagado < b.totalPagado) {
                return -1;
              }
              if (a.totalPagado > b.totalPagado) {
                return 1;
              }
              return 0;
            },
            responsive: [],
            width: 0,
          },
          {
            title: "Saldo Pendiente",
            dataIndex: "saldoPendiente",
            key: "saldoPendiente",
            sorter: (a, b) => {
              if (a.saldoPendiente < b.saldoPendiente) {
                return -1;
              }
              if (a.saldoPendiente > b.saldoPendiente) {
                return 1;
              }
              return 0;
            },
            render: (_, record) => (
              <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                <span>{dineroDisabledMask(record.saldoPendiente)}</span>
                {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
              </div>
            ),
            width: "35%",
            align: "right",
          },
          {
            title: "Estado",
            dataIndex: "estadoPago",
            key: "estadoPago",
            responsive: ["md"],
            render: (value, record, index) => {
              if (value === 0) {
                return (
                  <Tag key={index.toString()} color="blue" className="square-tag">
                    No pagada
                  </Tag>
                );
              }
              if (value === 2) {
                return (
                  <Tag key={index.toString()} color="orange" className="square-tag" style={{ fontSize: "10px" }}>
                    Pagada parcialmente
                  </Tag>
                );
              }
            },
            width: "34%",
          },
          {
            title: "Vencimiento",
            dataIndex: "accion",
            responsive: ["md"],
            key: "vencimiento",
            render: (value, record, index) => {
              if (moment() > moment(value.fechaVencimiento)) {
                return (
                  <Tag key={`vencido-${index}`} color="red" className="square-tag3">
                   {moment().diff(moment(value.fechaVencimiento), 'days')} días
                  </Tag>
                );
              }
              return null;
            },
            width: "24%",
          },
          {
            title: "Acción",
            dataIndex: "accion",
            key: "accion",
            align: "center",
            width: "25%",
            onHeaderCell: () => ({
              style: { textAlign: 'center', padding: '4px' }
            }),
            onCell: () => ({
              className: "acciones-sin-hover",
              style: { textAlign: 'center', padding: '4px' }
            }),
            render: (value, record, index) => {
              if(!value.poderPagar) return null;

              let buttons = [];
              const puedeEditarFechas = false; 
              if(this.props.permisoCambiarFecha){ 
                buttons.push(
                  <Tooltip key={`fechas-${index}`} title={"Modificar fechas"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<ScheduleOutlined />}
                      onClick={() => this.abrirModalEditarFechas(record)}
                      disabled={puedeEditarFechas}
                    >
                    </ButtonItem>
                  </Tooltip>
                )
              }

              const puedePagar = (value.estadoPago === 0 || value.estadoPago === 2) && this.props.permisoPagar;
              buttons.push(
                <Tooltip key={`pagar-${index}`} title={puedePagar ? "Pagar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    amarillo
                    icon={<DollarOutlined />}
                    onClick={() => puedePagar && this.pagarFactura(value._id, value.cheque)}
                    disabled={!puedePagar}
                  >
                  </ButtonItem>
                </Tooltip>
              );

              const puedeVerFactura = (value.estadoPago === 0 || value.estadoPago === 2) && this.props.permisoPagar;
              buttons.push(
                <Tooltip key={`ver-${index}`} title={puedeVerFactura ? "Ver Factura" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    azul
                    icon={<EyeOutlined />}
                    onClick={() => puedeVerFactura && this.props.history.push("/panel/verFacturaSinOrdenDeCompra", { id: record._id })}
                    disabled={!puedeVerFactura}
                  >
                  </ButtonItem>
                </Tooltip>
              );

              return <div className="acciones-container">{buttons}</div>;
            },
          },
        ];
    return (
      <>
        <PageHeader
          title={"Cuentas por Pagar: " + this.state.total}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
            {window.innerWidth > 1000 &&
              <SegmentedItem
                options={[{label: 'Todas', value: 3}, {label: 'Pagada Parcialmente', value: 2}, {label: 'Ordenes de Compra', value: 4}, {label: 'Agrupar por Proveedor', value: 5}]}
                onChange={(value) => {
                  if(value === 5){
                    this.consultarCuentasPorPagarProveedor()
                    this.setState({ agruparPorProveedor: true })
                  }else{
                    this.consultarCuentasPorPagar(value)
                    this.setState({ agruparPorProveedor: false })
                  }
                  this.setState({ valor: value })
                }}
                value={this.state.valor}
              />
          }
              {/* {<ButtonItem onClick={this.agrupar.bind(this)} type="primary">
                {this.state.agruparPorProveedor
                  ? "Facturas"
                  : "Agrupar por proveedor"}
              </ButtonItem>} */}
            </>
          }
        />
        <TableItem
          components={{
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          }}
          loading={this.state.loading}
          size="small"
          dataSource={
            this.state.agruparPorProveedor
              ? this.state.todasCuentasPorPagarProveedor
              : this.state.todasCuentasPorPagar
          }
          columns={columns}
          estadosLeyenda = {estadosLeyendaDinamicos}
          pagination={false}
          scroll={{ x: 'max-content' }}
          onRow={(record) => ({
            onDoubleClick: () => {
              if(this.state.valor === 5){
                this.verProveedor(record._id, record.proveedorNombre, record.cheque, record.accion?.rfc)
              } else {
                if (
                  (record.accion.estadoPago === 0 || record.accion.estadoPago === 2) &&
                  this.props.permisoPagar
                ) {
                  this.pagarFactura(record.accion._id, record.accion.cheque);
                }
              }
            },
          })}
        />
        <ModalEditarFechas
          visible={this.state.modalEditarFechas}
          factura={this.state.facturaSeleccionada}
          onCancel={() => this.cerrarModalEditarFechas(false)}
          onSuccess={() => this.cerrarModalEditarFechas(true)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoPagar:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ce2eff30e81b54183cfae"
      )?.activado,
    permisoCambiarFecha:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472e6554b2da7c85c1a8d19"
      )?.activado,
  };
};

export default connect(mapStateToProps)(CuentasPorPagar);
